export default __webpack_public_path__ + "static/media/right_mildArch.1c637c03.png";